import React, {useState, useEffect, useContext, useRef } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonInput, IonLabel, IonText, IonFooter, IonCheckbox } from '@ionic/react';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';

import { Modal_Onboarding_PortfolioDetail } from './Modal_Onboarding_PortfolioDetail';
import { Modal_Onboarding_ProductDetail } from './Modal_Onboarding_ProductDetail';
import { ViewInvoiceModal } from './Modal_ViewInvoice';
import { Registration_GeoLocation } from './Registration_GeoLocation';
import { Modal_Onboarding_Address } from './Modal_Onboarding_Address';


import '../../css/layout.css';




export function MerchantOnboarding_Details(props) {


    let authenticated_Zasava_Context = useContext(Auth_Zasava_Context);

    let [acctID, setAcctID] = useState(authenticated_Zasava_Context.acctID);
    const [schema, setSchemaName] = useState(authenticated_Zasava_Context.schema);
    let [sessionID, setSessionID ] = useState(authenticated_Zasava_Context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticated_Zasava_Context.baseURL);

    let [merchantID, setMerchantID] = useState(props.data.merchantID);
    let [merchantSchema, setMerchantSchemaName] = useState(props.data.merchantSchema);

    let [viewMerchantVerifyDetails, setMerchantVerifyDetails] = useState([]);

    let [viewGhanaIDModal, setViewGhanaIDModal] = useState(false);
    let [viewMerchantRegistrationModal, setViewMerchantRegistrationModal] = useState(false);
    let [viewMerchantAddressModal, setViewMerchantAddressModal] = useState(false);
    let [viewMerchantCoordinateModal, setViewMerchantCoordinateModal] = useState(false);
    let [viewCompanyMainImageModal, setViewCompanyMainImageModal] = useState(false);
    let [viewCompanyShowcaseModal, setViewCompanyShowcaseModal] = useState(false);

    let [merchantName, setMerchantName] = useState(null);
    let [merchantPhoneNumber, setMerchantPhoneNumber] = useState(null);
    let [merchantUpload_ghanaID, setMerchantUpload_ghanaID] = useState(null);
    let [merchantUpload_businessRegistrationID, setMerchantUpload_businessRegistrationID] = useState(null);
    let [merchantAddress, setMerchantAddress ] = useState({});

    let [latitude, setLatitude] = useState(null);
    let [longitude, setLongitude] = useState(null);
    let [merchantUpload_companyMainImage, setMerchantUpload_companyMainImage] = useState(null);
    let [companyShowcase, setCompanyShowcase] = useState(null);

    const [onboardingDateLogged, setOnboardingDateLogged] = useState(null);
    const [onboarding_staus_initial, setOnboarding_status_initial] = useState(null);
    const [onboarding_staus, setOnboarding_staus] = useState(null);


    let [merchantName_checked, setMerchantName_checked] = useState(false);
    let [merchantPhoneNumber_checked, setMerchantPhoneNumber_checked] = useState(false);
    let [merchantUpload_ghanaID_checked, setMerchantUpload_ghanaID_checked] = useState(false);
    let [merchantUpload_businessRegistrationID_checked, setMerchantUpload_businessRegistrationID_checked] = useState(false);
    let [merchantAddress_checked, setMerchantAddress_checked] = useState(false);
    let [merchantCoordinates_checked, setMerchantCoordinates_checked] = useState(false);
    let [merchantUpload_companyMainImage_checked, setMerchantUpload_companyMainImage_checked] = useState(false);
    let [companyShowcase_checked, setCompanyShowcase_checked] = useState(false);

    let [merchantName_checked_data, setMerchantName_checked_data] = useState(null);
    let [merchantPhoneNumber_checked_data, setMerchantPhoneNumber_checked_data] = useState(null);
    let [merchantUpload_ghanaID_checked_data, setMerchantUpload_ghanaID_checked_data] = useState(null);
    let [merchantUpload_businessRegistrationID_checked_data, setMerchantUpload_businessRegistrationID_checked_data] = useState(null);
    let [merchantAddress_checked_data, setMerchantAddress_checked_data] = useState({});
    let [latitude_checked_data, setLatitude_checked_data] = useState(null);
    let [longitude_checked_data, setLongitude_checked_data] = useState(null);
    let [merchantUpload_companyMainImage_checked_data, setMerchantUpload_companyMainImage_checked_data] = useState(null);
    let [companyShowcase_checked_data, setCompanyShowcase_checked_data] = useState(null);

    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);
    let [row_5, setRow_5] = useState(false);
    let [row_6, setRow_6] = useState(false);
    let [row_7, setRow_7] = useState(false);
    let [row_8, setRow_8] = useState(false);
    let [row_9, setRow_9] = useState(false);
    let [row_10, setRow_10] = useState(false);
    let [row_11, setRow_11] = useState(false);
    let [row_12, setRow_12] = useState(false);
    let [row_13, setRow_13] = useState(false);
    let [row_14, setRow_14] = useState(false);
    let [row_15, setRow_15] = useState(false);
    let [row_16, setRow_16] = useState(false);
    let [row_17, setRow_17] = useState(false);



    useEffect(() => {   

        setMerchantAddress([]);
        setMerchantAddress_checked_data([]);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: "74503_merchantOnboarding_details",
                user: acctID,
                schemaName: schema,
                xMerchantAccountID: props.data.merchantID,
                xMerchantSchema: props.data.merchantSchema,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');
            //for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            //{
                let cols = rows[0].split('|');
                let new_addres1 = cols[5].split(']');
                let new_addres2 = cols[5].split(' ');

                 //alert(cols);
                // alert(JSON.parse(cols[5]));
                // alert(JSON.parse(cols[5]).addressNumber);
                // alert(JSON.parse(cols[5]).streetName);


                setMerchantName(cols[1]);
                setMerchantPhoneNumber(cols[2]);
                setMerchantUpload_ghanaID(cols[3]);
                setMerchantUpload_businessRegistrationID(cols[4]);



                //setMerchantAddress((prevAddressList) => [...prevAddressList, address]);
                if(cols[5] != 'NULL')
                {

                    setMerchantAddress(JSON.parse(cols[5]));
                }
                else
                {
                    setMerchantAddress({});

                }

                setLatitude(cols[6]);
                setLongitude(cols[7]);
                setMerchantUpload_companyMainImage(cols[8]);
                setCompanyShowcase(cols[9]);
                setOnboardingDateLogged(cols[10]);
                setOnboarding_staus(cols[11])            
                    setOnboarding_status_initial(cols[11]);

                setMerchantVerifyDetails((prevViewRequisitionList) => {
                    return prevViewRequisitionList.concat({
                        merchantID: cols[0], 
                        merchantName: cols[1],
                        merchantMomoNumber: cols[2],
                        merchantUpload_ghanaID: cols[3],
                        merchantUpload_businessRegistrationID: cols[4],
                        merchantAddress: cols[5],
                        latitude: cols[6],
                        longitude: cols[7],
                        merchantUpload_companyMainImage: cols[8],
                        companyShowcase: cols[9],
                        date_logged: cols[10],
                        onboardingStatus: cols[11],

                        
                    })
                });
            //} 

                let cols2 = rows[1].split('|');

                setMerchantName_checked_data(cols2[1]);
                setMerchantPhoneNumber_checked_data(cols2[2]);
                setMerchantUpload_ghanaID_checked_data(cols2[3]);
                setMerchantUpload_businessRegistrationID_checked_data(cols2[4]);

                //setMerchantAddress_checked_data((prevAddressList) => [...prevAddressList, address]);

                if(cols2[5] != 'NULL')
                {
                    setMerchantAddress_checked_data(JSON.parse(cols2[5]));
                }
                else
                {
                    setMerchantAddress_checked_data({});

                }

                setLatitude_checked_data(cols2[6]);
                setLongitude_checked_data(cols2[7]);
                setMerchantUpload_companyMainImage_checked_data(cols2[8]);
                setCompanyShowcase_checked_data(cols2[9]);


                if (cols2[1] !== "" && cols2[1] !== "NULL" && cols2[1] !== "undefined") setMerchantName_checked(true);
                if (cols2[2] !== "" && cols2[2] !== "NULL" && cols2[2] !== "undefined") setMerchantPhoneNumber_checked(true);
                if (cols2[3] !== "" && cols2[3] !== "NULL" && cols2[3] !== "undefined") setMerchantUpload_ghanaID_checked(true);
                if (cols2[4] !== "" && cols2[4] !== "NULL" && cols2[4] !== "undefined") setMerchantUpload_businessRegistrationID_checked(true);
                if (cols2[5] !== "" && cols2[5] !== "NULL" && cols2[5] !== "undefined") setMerchantAddress_checked(true);
                if (cols2[6] !== "" && cols2[6] !== "NULL" && cols2[6] !== "undefined") setMerchantCoordinates_checked(true);
                if (cols2[7] !== "" && cols2[7] !== "NULL" && cols2[7] !== "undefined") setMerchantCoordinates_checked(true);
                if (cols2[8] !== "" && cols2[8] !== "NULL" && cols2[8] !== "undefined") setMerchantUpload_companyMainImage_checked(true);
                if (cols2[9] !== "" && cols2[9] !== "NULL" && cols2[9] !== "undefined") setCompanyShowcase_checked(true);

        })

    }, [])   



    function updateOnboardingStatus()
    {
        
        let formData = new FormData();
        formData.append('Tracker', '74503_merchantOnboarding_status_update');
        formData.append('props', props.data.status);
        formData.append('user', acctID);
        formData.append('schemaName', schema);
        formData.append('xMerchantAccountID', props.data.merchantID);
        formData.append('xMerchantSchema', props.data.merchantSchema);
        formData.append('xMerchantName', merchantName);
        formData.append('xMerchantPhoneNumber', merchantPhoneNumber);
        formData.append('xMerchantUpload_ghanaID', merchantUpload_ghanaID);
        formData.append('xMerchantUpload_businessRegistrationID', merchantUpload_businessRegistrationID);
        formData.append('xBusinessAddress', JSON.stringify(merchantAddress));
        formData.append('xLatitude', latitude);
        formData.append('xLongitude', longitude);
        formData.append('xMerchantUpload_companyMainImage', merchantUpload_companyMainImage);
        formData.append('xCompanyShowcase', companyShowcase);
        formData.append('xMerchantOnboardingStatus', onboarding_staus);


        formData.append('xMerchantName_checked_data', merchantName_checked_data);
        formData.append('xMerchantPhoneNumber_checked_data', merchantPhoneNumber_checked_data);
        //formData.append('xMerchantUpload_ghanaID_checked_data', merchantUpload_ghanaID_checked_data);
        //formData.append('xMerchantUpload_BusinessRegistrationID_checked_data', merchantUpload_businessRegistrationID_checked_data);
        formData.append('xBusinessAddress_checked_data', JSON.stringify(merchantAddress_checked_data));
        formData.append('xLatitude_checked_data', latitude_checked_data);
        formData.append('xLongitude_checked_data', longitude_checked_data);
        //formData.append('xMerchantUpload_companyMainImage_checked_data', merchantUpload_companyMainImage_checked_data);
        //formData.append('xcompanyShowcase_checked_data', companyShowcase_checked_data);


        formData.append('sessionID', sessionID);

        //alert(merchantAddress);
        //alert(JSON.stringify(merchantAddress));

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }

        
        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function convertMerchantToActive()
    {
        let formData = new FormData();
        formData.append('Tracker', '74503_convertMerchantToActive');
        formData.append('user', acctID);
        formData.append('schemaName', schema);
        formData.append('xMerchantAccountID', props.data.merchantID);
        formData.append('xMerchantSchema', props.data.merchantSchema);
        formData.append('xBusinessType', props.data.businessType);
        formData.append('sessionID', sessionID);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        
        //let url;

        // if(props.data.status == 'user_applicant_onboarding')
        // {
        //    url = baseURL+'public_to_internal';
        // }
        // else
        // {
        //     url = baseURL+'zsava_internal_indexApp'
        // }
        
        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function deleteMerchant()
    {
        let formData = new FormData();
        formData.append('Tracker', '74503_delete_onboarding_merchant');
        formData.append('user', acctID);
        formData.append('schemaName', schema);
        formData.append('xMerchantAccountID', props.data.merchantID);
        formData.append('xMerchantSchema', props.data.merchantSchema);
        formData.append('sessionID', sessionID);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        

        let url;

        if(props.data.status == 'public_to_internal')
        {
           url = baseURL+'zsava_internal_indexApp';
        }
        else
        {
            url = baseURL+'zsava_internal_indexApp'
        }
        fetch(url, requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function retrieveCurrentGeolocation(event) 
    {
        //alert("in get current registration coordinates");
        // alert(event);
        // alert(event[0]);
        // alert(event[1]);

        setLatitude(event[0]);
        setLongitude(event[1]);

        alert("Coordinates Set.  Latitude: "+event[0]+".  Longitude: "+event[1]);

    }

    function xinitialMerchantName_confirm(event) {
        if (event[0] == true) {
            setMerchantName_checked(event[0]);
            setMerchantName_checked_data(event[1]);
        } else if (event[0] == false) {
            setMerchantName_checked(event[0]);
            setMerchantName_checked_data(null);
        }
    }
    
    function xinitialMerchantPhoneNumber_confirm(event) {
        if (event[0] == true) {
            setMerchantPhoneNumber_checked(event[0]);
            setMerchantPhoneNumber_checked_data(event[1]);
        } else if (event[0] == false) {
            setMerchantPhoneNumber_checked(event[0]);
            setMerchantPhoneNumber_checked_data(null);
        }
    }
    
    function xinitialMerchantUpload_ghanaID_confirm(event) {
        if (event[0] == true) {
            setMerchantUpload_ghanaID_checked(event[0]);
            setMerchantUpload_ghanaID_checked_data(event[1]);
        } else if (event[0] == false) {
            setMerchantUpload_ghanaID_checked(event[0]);
            setMerchantUpload_ghanaID_checked_data(null);
        }
    }

    function xinitialMerchantBusinessRegistrationID_confirm(event) {
        if (event[0] == true) {
            setMerchantUpload_businessRegistrationID_checked(event[0]);
            setMerchantUpload_businessRegistrationID_checked_data(event[1]);
        } else if (event[0] == false) {
            setMerchantUpload_businessRegistrationID_checked(event[0]);
            setMerchantUpload_businessRegistrationID_checked_data(null);
        }
    }
    
    function xinitialMerchantAddress_confirm(event) {
        if (event[0] == true) {
            setMerchantAddress_checked(event[0]);
            setMerchantAddress_checked_data(event[1]);
        } else if (event[0] == false) {
            setMerchantAddress_checked(event[0]);
            setMerchantAddress_checked_data(null);
        }
    }

    function xinitialMerchantBusinessCoordinates_confirm(event) {
        if (event[0] == true) {
            setMerchantCoordinates_checked(event[0]);
            setLatitude(event[1]);
            setLongitude(event[2])
        } else if (event[0] == false) {
            setMerchantCoordinates_checked(event[0]);
            setLatitude_checked_data(null);
            setLongitude_checked_data(null)        
        }
    }

    function xinitialMerchantUpload_companyMainImage_confirm(event) {
        if (event[0] == true) {
            setMerchantUpload_companyMainImage_checked(event[0]);
            setMerchantUpload_companyMainImage_checked_data(event[1]);
        } else if (event[0] == false) {
            setMerchantUpload_companyMainImage_checked(event[0]);
            setMerchantUpload_companyMainImage_checked_data(null);
        }
    }


    function xinitialCompanyShowcase_confirm(event) {
        if (event[0] == true) {
            setCompanyShowcase_checked(event[0]);
            setCompanyShowcase(event[1]);
            setCompanyShowcase_checked_data(event[1]);
        } else if (event[0] == false) {
            setCompanyShowcase_checked(event[0]);
            setCompanyShowcase(null);
            setCompanyShowcase_checked_data(null);
        }
    }

    function handleFileChange_ghanaID(event) {


        const file = event.target.files ? event.target.files[0] : null;
        setMerchantUpload_ghanaID(file);
        //setFileName(file ? file.name : '');
    }
    function handleFileChange_businessRegistrationID(event) {


        const file = event.target.files ? event.target.files[0] : null;
        setMerchantUpload_businessRegistrationID(file);
        //setFileName(file ? file.name : '');
    }
    function handleFileChange_businessAddress(event) {


        const file = event.target.files ? event.target.files[0] : null;
        setMerchantAddress(file);
        //setFileName(file ? file.name : '');
    }

    function handleFileChange_companyMainImage(event) {


        const file = event.target.files ? event.target.files[0] : null;
        setMerchantUpload_companyMainImage(file);
        //setFileName(file ? file.name : '');
    }


    function viewGhanaIDModalHandler(event) {


        //setApplicationID(event[1]);
        setMerchantUpload_ghanaID(event[2]);
        setViewGhanaIDModal(event[0]);

    }

    function viewMerchantBusinessRegistrationIDHandler(event) {


        //setApplicationID(event[1]);
        setMerchantUpload_businessRegistrationID(event[2]);
        setViewMerchantRegistrationModal(event[0]);

    }

    function viewMerchantAddressHandler(event) {


        //setApplicationID(event[1]);
        //setMerchantAddress(event[2]);
        setViewMerchantAddressModal(event[0]);

    }

    function setUpdateAddress(event)
    {
        // alert("In Update Address");
        // alert(event)

        setMerchantAddress({});

        let address = {
            addressNumber: event[0],
            streetName: event[1],
            city: event[2],
            cityDistrict: event[3],
            digitalAddress: event[4],
            country: event[5],
            countryRegion: event[6],
        }

        //setMerchantAddress((prevAddressList) => [...prevAddressList, address]);
        setMerchantAddress(address);

        // alert("Update Set");
        // alert(address);


    }

    function viewMerchantBusinessCordinatesHandler(event) {


        //setApplicationID(event[1]);
        setLatitude(event[1]);
        setLongitude(event[2]);
        setViewMerchantCoordinateModal(event[0]);

    }

    function viewCompanyMainImageHandler(event) {


        //setApplicationID(event[1]);
        setMerchantUpload_companyMainImage(event[2]);
        setViewCompanyMainImageModal(event[0]);

    }

    function viewCompanyShowcaseHandler(event) {


        //setApplicationID(event[1]);
        setCompanyShowcase(event[1]);
        setViewCompanyShowcaseModal(event[0]);

    }


    function closeModalHandler() {

        setMerchantVerifyDetails([]);
        props.closeModal(false);
    }


    //alert(merchantAddress);
    //alert(merchantAddress.length );
    //alert(props.data.status);


    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader className='grid_header'>
            <IonGrid >

                    <IonRow>
                        <IonCol> ONBOARDING</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> Merchant ID</IonCol>
                        <IonCol> Merchant Name</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> {props.data.merchantID} </IonCol>
                        <IonCol> {props.data.merchantName} </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='grid_content'>

            {viewMerchantVerifyDetails.map((detailData) =>   {
            return (
            <IonGrid >
                <IonRow >
                    <IonCol size='4' >Category</IonCol>
                    <IonCol size='4'>Value</IonCol>
                    <IonCol size='4' >Action</IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='4'>
                        <IonText>Merchant Name</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_1 == true && <IonInput type='text' value={merchantName} onIonChange={(e) => setMerchantName(e.detail.value)}></IonInput>}
                        {row_1 == false && <IonText>{merchantName}</IonText>}
                    </IonCol>
                    {row_1 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_1(true)}>Update</IonButton>
                    </IonCol>}
                    {row_1 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_1(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_1 == false && <IonCol size='1'>
                        <IonCheckbox checked={merchantName_checked} onIonChange={(e) => xinitialMerchantName_confirm([e.detail.checked, merchantPhoneNumber])} />
                    </IonCol>}
                </IonRow>
                <IonRow>
                    <IonCol size='4'>
                        <IonText>MTN Momo Number</IonText>
                    </IonCol>
                    <IonCol size='4'>
                        {row_2 == true && <IonInput type='text' value={merchantPhoneNumber} onIonChange={(e) => setMerchantPhoneNumber(e.detail.value)}></IonInput>}
                        {row_2 == false && <IonText>{merchantPhoneNumber}</IonText>}
                    </IonCol>
                    {row_2 == false && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_2(true)}>Update</IonButton>
                    </IonCol>}
                    {row_2 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_2(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_2 == false && <IonCol size='1'>
                        <IonCheckbox checked={merchantPhoneNumber_checked} onIonChange={(e) => xinitialMerchantPhoneNumber_confirm([e.detail.checked, merchantPhoneNumber])} />
                    </IonCol>}
                </IonRow>
                <IonRow>
                    <IonCol>
                        <IonText>Ghana ID</IonText>
                    </IonCol>
                    <IonCol>
                        {row_3 == true && 
                            <input
                                type="file"
                                accept=".doc,.docx,.pdf,.jpeg,.jpg,.png,.odt"
                                onChange={(event) => handleFileChange_ghanaID(event)}
                            />}
                        {row_3 == false && <IonButton className='gridResultColumnButton' onClick={() => viewGhanaIDModalHandler([true, detailData.merchantID, detailData.merchantUpload_ghanaID])}> View </IonButton>}
                    </IonCol>
                    {row_3 == false && <IonCol>
                        <IonButton className='small_button' onClick={() => setRow_3(true)}>Update</IonButton>
                    </IonCol>}
                    {row_3 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_3(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_3 == false && <IonCol>
                        <IonCheckbox checked={merchantUpload_ghanaID_checked} onIonChange={(e) => xinitialMerchantUpload_ghanaID_confirm([e.detail.checked, merchantUpload_ghanaID])} />
                    </IonCol>}
                </IonRow>

                <IonRow>
                    <IonCol size='4'>
                        <IonText>Business Registration ID</IonText>
                    </IonCol>
                    <IonCol>
                        {row_4 == true && 
                            <input
                                type="file"
                                accept=".doc,.docx,.pdf,.jpeg,.jpg,.png,.odt"
                                onChange={(event) => handleFileChange_businessRegistrationID(event)}
                            />}
                        {row_4 == false && <IonButton className='gridResultColumnButton' onClick={() => viewMerchantBusinessRegistrationIDHandler([true, detailData.merchantID, detailData.merchantUpload_businessRegistrationID])}> View </IonButton>}
                    </IonCol>
                    {row_4 == false && <IonCol>
                        <IonButton className='small_button' onClick={() => setRow_4(true)}>Update</IonButton>
                    </IonCol>}
                    {row_4 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_4(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_4 == false && <IonCol>
                        <IonCheckbox checked={merchantUpload_businessRegistrationID_checked} onIonChange={(e) => xinitialMerchantBusinessRegistrationID_confirm([e.detail.checked, merchantUpload_businessRegistrationID])} />
                    </IonCol>}
                </IonRow>
                <IonRow>
                    <IonCol size='4'>
                        <IonText>Business Address</IonText>
                    </IonCol>
                    <IonCol>
                        Address Number: {merchantAddress.addressNumber}
                        Street Name: {merchantAddress.streetName}
                        City: {merchantAddress.city}
                        CityDistrict: {merchantAddress.cityDistrict}   
                    </IonCol>
                    <IonCol>
                        <IonButton className='small_button' onClick={() => viewMerchantAddressHandler([true, detailData.merchantID])}>Update</IonButton>
                    </IonCol>
                    {row_5 == false && <IonCol>
                        <IonCheckbox checked={merchantAddress_checked} onIonChange={(e) => xinitialMerchantAddress_confirm([e.detail.checked, merchantAddress])} />
                    </IonCol>}
                </IonRow>
                <IonRow>
                    <IonCol size='4'>
                        <IonText>Business Coordinates</IonText>
                    </IonCol>
                    <IonCol>
                        {row_6 == false && <IonButton className='gridResultColumnButton' onClick={() => viewMerchantBusinessCordinatesHandler([true, detailData.merchantID, detailData.latitude, detailData.longitude])}> Set Coordinates </IonButton>}
                    </IonCol>
                    {row_6 == false && <IonCol>
                        <IonButton className='small_button' onClick={() => setRow_6(true)}>Update</IonButton>
                    </IonCol>}
                    {row_6 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_6(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_6 == false && <IonCol>
                        <IonCheckbox checked={merchantCoordinates_checked} onIonChange={(e) => xinitialMerchantBusinessCoordinates_confirm([e.detail.checked, latitude, longitude])} />
                    </IonCol>}
                </IonRow>
                <IonRow>
                    <IonCol size='4'>
                        <IonText>Company Main Image</IonText>
                    </IonCol>
                    <IonCol>
                        {row_7 == true && 
                            <input
                                type="file"
                                accept=".doc,.docx,.pdf,.jpeg,.jpg,.png,.odt"
                                onChange={(event) => handleFileChange_companyMainImage(event)}
                            />}
                        {row_7 == false && <IonButton className='gridResultColumnButton' onClick={() => viewCompanyMainImageHandler([true, detailData.merchantID, detailData.merchantUpload_companyMainImage])}> View </IonButton>}
                    </IonCol>
                    {row_7 == false && <IonCol>
                        <IonButton className='small_button' onClick={() => setRow_7(true)}>Update</IonButton>
                    </IonCol>}
                    {row_7 == true && <IonCol size='3'>
                        <IonButton className='small_button' onClick={() => setRow_7(false)}>Confirm</IonButton>
                    </IonCol>}
                    {row_7 == false && <IonCol>
                        <IonCheckbox checked={merchantUpload_companyMainImage_checked} onIonChange={(e) => xinitialMerchantUpload_companyMainImage_confirm([e.detail.checked, merchantUpload_companyMainImage])} />
                    </IonCol>}
                </IonRow>
                <IonRow>
                    <IonCol size='4'>
                        <IonText>Company Showcase</IonText>
                    </IonCol>
                    <IonCol size='3'>
                        {row_8 == false &&  <IonButton class='gridResultColumnButton' onClick={() => viewCompanyShowcaseHandler([true, detailData.companyShowcase])}> View </IonButton>}
                    </IonCol>
                    {row_8 == false && <IonCol>
                        <IonCheckbox checked={companyShowcase_checked} onIonChange={(e) => xinitialCompanyShowcase_confirm([e.detail.checked, "confirmed"])} />
                    </IonCol>}
                </IonRow>
                <IonRow >
                    <IonCol size='6'>                        
                        <IonLabel htmlFor="mmProvider">Onboading Status </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        <select name="onboarding_status" id='onboarding_status' value={onboarding_staus} onChange={(e) => setOnboarding_staus(e.target.value)}>
                            <option value='pending'>Pending</option>
                            <option value='completed'>Completed</option>
                        </select>
                    </IonCol>
                </IonRow>
                </IonGrid>
                    )
                }
            )}

            {authenticated_Zasava_Context.accessRights[0] == 'sales' &&
                        <IonGrid>
                        <IonRow>
                                <IonCol>
                                {onboarding_staus_initial != 'completed' && <IonButton onClick={() => updateOnboardingStatus()}>Save</IonButton>}
                                { onboarding_staus_initial == 'completed' && <IonText >PENDING REVIEW</IonText>}
                                </IonCol>
                            </IonRow>
                        </IonGrid>}

            {(authenticated_Zasava_Context.accessRights[0] == 'admin' || authenticated_Zasava_Context.accessRights[0] == 'super_z') && 
                        <IonGrid className='gridText_admin_onboarding'>
                            <IonRow>
                                <IonCol>
                                    <IonButton onClick={() => updateOnboardingStatus()}>Save</IonButton>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='6'>
                                    <IonButton onClick={() => convertMerchantToActive()}>Activate Merchant</IonButton>
                                </IonCol>
                                <IonCol size='6'>
                                    <IonButton onClick={() => deleteMerchant()}>Delete Merchant</IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>}

        </IonContent>

        
        <IonFooter className='grid_footer'>
                        
                        <IonButton onClick={() => closeModalHandler(false)}>Cancel </IonButton>

        </IonFooter>

        {viewGhanaIDModal == true && <ViewInvoiceModal openModal={ viewGhanaIDModal } closeModal={() => viewGhanaIDModalHandler(false)} data={{
                                        fileLocation: merchantUpload_ghanaID, 
                                        merchantID: props.data.merchantID, 
                                        }}></ViewInvoiceModal>}

        {viewMerchantRegistrationModal == true && <ViewInvoiceModal openModal={ viewMerchantRegistrationModal } closeModal={() => viewMerchantBusinessRegistrationIDHandler(false)} data={{
                                                fileLocation: merchantUpload_businessRegistrationID, 
                                                merchantID: props.data.merchantID, 
                                                }}></ViewInvoiceModal>}
        
        {viewMerchantAddressModal == true && <Modal_Onboarding_Address openModal={ viewMerchantAddressModal } closeModal={() => setViewMerchantAddressModal(false)} updateAddress={(event) => setUpdateAddress(event)} data={{
                                                merchantID: props.data.merchantID, 
                                                }}></Modal_Onboarding_Address>}


        {viewMerchantCoordinateModal == true && <Registration_GeoLocation gps_location={retrieveCurrentGeolocation} openModal={ viewMerchantCoordinateModal } closeModal={() => setViewMerchantCoordinateModal(false)}></Registration_GeoLocation>}


        {viewCompanyMainImageModal == true && <ViewInvoiceModal openModal={ viewCompanyMainImageModal } closeModal={() => viewCompanyMainImageHandler(false)} data={{
                                                fileLocation: merchantUpload_companyMainImage, 
                                                merchantID: props.data.merchantID, 
                                                }}></ViewInvoiceModal>}

        {(viewCompanyShowcaseModal == true && props.data.businessType == 'T2') && <Modal_Onboarding_PortfolioDetail openModal={ viewCompanyShowcaseModal } closeModal={() => setViewCompanyShowcaseModal(false)} data={{
                        merchantID: props.data.merchantID,
                        merchantSchema: props.data.merchantSchema,
                        }}></Modal_Onboarding_PortfolioDetail>}

        {(viewCompanyShowcaseModal == true && props.data.businessType == 'T3') && <Modal_Onboarding_ProductDetail openModal={ viewCompanyShowcaseModal } closeModal={() => setViewCompanyShowcaseModal(false)} data={{
                        merchantID: props.data.merchantID,
                        merchantSchema: props.data.merchantSchema,
                        }}></Modal_Onboarding_ProductDetail>}

    </IonModal>) : null}
    </React.Fragment>
    )
}